import { ArrowIcon, Box, Button, Flex, Image, Text } from '@modusign/design-system';

import warningIcon from '@app/assets/icons/icon-warning-white-h17.svg';
import EnhancedToolTip from '@app/components/EnhancedToolTip';

interface ContractLinkCreateSubmitButtonProps {
  disabled: boolean;
  isLoading: boolean;
  onClick: () => void;
}

const defaultProps = {
  disabled: false,
};

function ContractLinkCreateSubmitButton({
  disabled,
  onClick,
  isLoading,
}: ContractLinkCreateSubmitButtonProps) {
  return (
    <Box
      display="inline"
      position="relative"
      sx={{
        '.ContractLinkCreateSubmitButton__tool-tip': {
          display: 'none',
          left: '50%',
          position: 'absolute',
          top: '50%',
          whiteSpace: 'normal',
          width: '220px',
        },
        '&:hover': {
          '.ContractLinkCreateSubmitButton__tool-tip': {
            display: 'block',
          },
        },
      }}
    >
      <Button
        disabled={disabled}
        isLoading={isLoading}
        ml={3}
        sx={{ position: 'relative' }}
        variant="primary"
        onClick={onClick}
      >
        링크 만들기
        <ArrowIcon direction="right" ml={1} />
        {disabled && (
          <EnhancedToolTip
            arrowDirection="bottom"
            className="ContractLinkCreateSubmitButton__tool-tip align-left"
          >
            <Flex alignItems="start" as="p">
              <Image alt="" src={warningIcon} />
              <Text ml={2}>안내 사항을 확인하고, 모든 체크박스란에 체크해 주세요.</Text>
            </Flex>
          </EnhancedToolTip>
        )}
      </Button>
    </Box>
  );
}

ContractLinkCreateSubmitButton.defaultProps = defaultProps;

export default ContractLinkCreateSubmitButton;
